import { calculateMileageIncreasing } from "components/util/Geometry";
import { jsonPostV2, handleJsonPostError } from "./apiUtils";
import _ from "lodash";

export const ROUTE_HISTORY = "ROUTE_HISTORY";
export const CONSOLIDATED_HISTORY = "CONSOLIDATED_HISTORY";
export const ROUTE_HISTORY_TOGGLE = "ROUTE_HISTORY_TOGGLE";
export const FETCHING_HISTORY = "FETCHING_HISTORY";
export const SHOW_ROUTE_HISTORY = "SHOW_ROUTE_HISTORY";
export const CLEAR_ROUTE_HISTORY = "CLEAR_ROUTE_HISTORY";

export function consolidatedHistory(key, success, history, routePosition, qa) {
    return (dispatch, getState) => {
        const state = getState();

        const currentSessionTags = _.get(state.sessions[state.playlist.data.routeID], "tags", []);
        const sessionIsBackward = _.includes(currentSessionTags, "Backward");

        const mileageIncreasing = calculateMileageIncreasing(
            state.playlist.position.playlistDistance,
            state.playlist.data.route_locations_v2,
            sessionIsBackward,
        );

        const currentHeading = state.playlist.position.heading;
        const degrees = (currentHeading * 180) / Math.PI;
        const clockwiseDegrees = (90 - degrees) % 360;
        let positiveBearing = (clockwiseDegrees + 360) % 360;

        if (sessionIsBackward) {
            positiveBearing -= 180;
        }

        const pointsWithBearing = _.clone(
            history.map((point) => {
                let bearing = positiveBearing;

                if (mileageIncreasing !== point.mileage_increasing) {
                    bearing -= 180;
                }

                return {
                    ...point,
                    bearing,
                };
            }),
        );

        dispatch({
            type: CONSOLIDATED_HISTORY,
            key,
            success,
            history: pointsWithBearing,
            routePosition,
            qa,
        });
    };
}

export function routeHistory(key, success, history) {
    return {
        type: ROUTE_HISTORY,
        key,
        success,
        history,
    };
}

export function setRouteHistoryHidden(hidden) {
    return {
        type: ROUTE_HISTORY_TOGGLE,
        hidden,
    };
}

export const setFetchingHistory = (fetchingTimestamp) => {
    return {
        type: FETCHING_HISTORY,
        fetchingTimestamp,
    };
};

export const toggleShowHistory = (show) => {
    return {
        type: SHOW_ROUTE_HISTORY,
        show,
    };
};
let routeHistoryRequests = [];

export function getPagedRouteHistory(routeLocation, sameTrackOnly, qaFiltered) {
    return (dispatch, getState) => {
        if (_.isNil(routeLocation?.position)) return;

        const state = getState();
        const fetchingPosition = state.playlist.consolidatedHistory.fetching;
        const fetchedPosition = state.playlist.consolidatedHistory.requestedPosition;
        const qaFetched = state.playlist.consolidatedHistory.qaFetched;

        const routePosition = routeLocation.position.toFixed(3);

        if ((fetchingPosition === routePosition || fetchedPosition === routePosition) && qaFiltered === qaFetched) {
            return;
        }

        routeHistoryRequests.forEach((historyRequest) => {
            historyRequest.abort("user_abort");
        });
        routeHistoryRequests = [];

        dispatch(setFetchingHistory(routePosition));
        dispatch(consolidatedHistoryLookup(routeLocation, sameTrackOnly, qaFiltered, true));
    };
}

export function consolidatedHistoryLookup(route_location, same_track_only, qaFiltered, first = false, page = 1) {
    const routePosition = route_location.position.toFixed(3);
    return (dispatch, getState) => {
        let postBody = {
            action: "consolidated_history_paged",
            system_id: route_location.system,
            route_id: route_location.route,
            route_position: routePosition,
            qa_filtered: qaFiltered,
            page: page,
        };
        if (same_track_only && route_location.subposition !== null) {
            postBody.route_subposition = route_location.subposition;
        }
        let url = "/route";
        const abortController = new AbortController();
        const requestId = `${routePosition}:${page}:${Date.now()}`;

        routeHistoryRequests.push(abortController);

        if (page === 1) {
            dispatch({ type: CLEAR_ROUTE_HISTORY });
        }

        const removeCompletedRequest = () => {
            routeHistoryRequests = routeHistoryRequests.filter((r) => r.id !== requestId);
        };

        return jsonPostV2(url, getState(), postBody, dispatch, false, abortController.signal)
            .then((response) => {
                removeCompletedRequest();

                const state = getState();
                const forceFilters = _.get(state, ["userDetails", "sessionConfig", "force_filters"], false);
                const sessionIds = forceFilters ? new Set(state.sessionList) : null;

                const uniqueStreamPoints = (response?.history ?? [])
                    .filter((p) => !sessionIds || sessionIds.has(p.session_id))
                    .flatMap((point) => {
                        const videoStreamIds = point.video_stream_ids ?? [];
                        if (!videoStreamIds.length && point.inspection) return [point];

                        const streams = point.stream_info ?? [];
                        return streams.filter((s) => videoStreamIds.includes(s.source)).map((stream) => ({ ...point, stream_info: stream }));
                    });

                dispatch(consolidatedHistory(routePosition, true, uniqueStreamPoints, routePosition, qaFiltered));

                if (response.has_next) {
                    dispatch(consolidatedHistoryLookup(route_location, same_track_only, qaFiltered, false, page + 1));
                }

                if (first) {
                    dispatch(setFetchingHistory(false));
                }
            })
            .catch((error) => {
                if (error !== "user_abort") {
                    handleJsonPostError("Error finding consolidated route history", "An error occurred while searching consolidated route history", error);
                    dispatch(consolidatedHistory(routePosition, false, []));
                }
            });
    };
}
